import { FC, useCallback, useEffect, useState } from "react";
import { Paginator } from "primereact/paginator";
import { GLOBAL_DEFAULT } from "../../../constants";

export interface ICustomPaginator {
  data: string;
  onPageChange: any;
  tableRecords: any;
  currentPage?: any;
  rowPerPage?: any;
}

/**
 * Render Custom Pagination
 *
 * @param {{ data: any; onPageChange: any; tableRecords: any; }} param0
 * @param {*} param0.data
 * @param {*} param0.onPageChange
 * @param {*} param0.tableRecords
 * @returns {*}
 */

const CustomPaginator: FC<ICustomPaginator> = ({
  data,
  onPageChange,
  tableRecords,
  currentPage,
  rowPerPage,
}) => {
  const [first, setFirst] = useState(
    currentPage || GLOBAL_DEFAULT.PAGINATOR_FIRST,
  );
  const [rows, setRows] = useState(rowPerPage || GLOBAL_DEFAULT.PAGINATOR_ROWS);

  const totalRecords =
    data === undefined ? GLOBAL_DEFAULT.PAGINATOR_FIRST : data.length;

  const handlePageChange = useCallback(
    (event: any) => {
      setFirst(event.first);
      setRows(event.rows);
      const newCurrentPage = Math.floor(event.first / event.rows) + 1;
      // Call the onPageChange prop to send the currentPage to the parent component
      onPageChange(newCurrentPage, event.rows);
    },
    [onPageChange],
  );

  useEffect(() => {
    handlePageChange({ first: (first - 1) * rows, rows });
  }, []);

  const template2 = {
    layout:
      "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    CurrentPageReport: () => {
      if (totalRecords === 0) {
        return (
          <span className="current-page-report mx-xl-1 px-3 px-xl-4 text-center">
            0-0 of 0
          </span>
        );
      } else {
        const start = (currentPage - 1) * rows + 1;
        const end = start - 1 + totalRecords;
        return (
          <span className="current-page-report mx-xl-1 px-3 px-xl-4 text-center">
            {start}-{end} of{" "}
            {tableRecords === undefined || tableRecords === null
              ? totalRecords
              : tableRecords}
          </span>
        );
      }
    },
  };

  return (
    <Paginator
      first={first}
      rows={rows}
      totalRecords={
        tableRecords === null || tableRecords === undefined
          ? totalRecords
          : tableRecords
      }
      onPageChange={handlePageChange}
      rowsPerPageOptions={GLOBAL_DEFAULT.CUSTOM_PAGINATOR_VALUES}
      template={template2}
    />
  );
};

export default CustomPaginator;
